"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableDrillTargets = void 0;
// (C) 2007-2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
function getAvailableDrillTargets(dv) {
    var measureDescriptors = dv
        .meta()
        .measureDescriptors()
        .map(function (measure) { return ({
        measure: measure,
        attributes: dv.meta().attributeDescriptors(),
    }); });
    var rowAttributeItems = dv
        .meta()
        .attributeDescriptorsForDim(0)
        .map(function (attribute, _index, attributes) { return ({
        attribute: attribute,
        intersectionAttributes: sdk_ui_1.getIntersectionAttributes(attribute, attributes),
    }); });
    return {
        measures: measureDescriptors,
        attributes: rowAttributeItems,
    };
}
exports.getAvailableDrillTargets = getAvailableDrillTargets;
//# sourceMappingURL=drillTargets.js.map